export const filters = {
  onChangeFilters: (store, payload) => {
    store.setState({ filters: payload });
  },
};
